// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ThemeToggle_toggleBtn__Z34Bm","icon":"ThemeToggle_icon__1oE9R"};